import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { action, computed, observable, reaction, runInAction } from 'mobx'
import { Button, Col, Modal } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
// import get from 'lodash/get'
import {
  i18nTranslate,
  getLiveEventStatus,
  isFeatureEnabled,
  isExpressCheckout,
  getCheckoutGTMPageData,
  checkMysiteOrPersonalOffer,
  isSubscriptionOverrideCheckoutPage,
  postAgreedTerm,
  getMysiteCartUrl,
  isINMarket,
  isLATAM,
  isGPSEnabled,
  getDefaultPaymentMethod,
  isTwikeyPaymentName,
  isLegacyTwikeyPaymentName,
  isSepaPaymentType,
  isPaymetric3DSProcessor,
  isExternalGPSCreditCardPaymentName,
  shouldDisableLiveEventCartAction,
  isCSRActOnBehalfSession,
} from 'src/utils'
import { pageNames } from 'src/routes/pathParams'
import {
  IS_BROWSER,
  trackGTMEvents,
  trackAddShippingInfoEvent,
  getCheckoutProduct,
  getCheckoutProductV2,
  trackErrorInInstana,
  getBrowserType,
  deleteFromLocalStorage,
  getGuestSignupOrigin,
  convertToBoolean,
  trackPathToPurchasePurchaseEvent,
  enableNewFeature,
  CHECKOUT_EVENT_TYPES,
  trackCustomCheckoutEvent,
  getGPSConfig,
} from 'src/utils'
import {
  cartContainer,
  customerContainer,
  checkoutContainer,
  loyaltyContainer,
  paypalContainer,
  venmoContainer,
  sessionContainer,
  googlePayContainer,
  applepayContainer,
  klarnaContainer,
  accountsContainer,
  multipleSubscriptionContainer,
  nuskinSubscriptionContainer,
  tokenExContainer,
  paymetricContainer,
  mysiteContainer,
} from 'src/models'
import { TokenExCvvContainer, savedCardsContainer } from 'src/models/TokenEx'
import { PaymetricSavedCardCvvContainer } from 'src/models/Paymetric'
import TagManager from 'react-gtm-module'
import { toastState, overlayState } from 'src/views/components'
import { SEPA } from 'src/utils/constant'
import { checkIsNativeApp } from 'src/utils/reactNativeAppUtils'
import { alertMessageKeys } from 'src/views/components/CartBlock/fixture'
import {
  isFlexibleSubscriptionFlagEnabled,
  isMultipleSubscriptionFlagEnabled,
  isToShowMultipleSubscriptionOptionsInCart,
  isSubscriptionFlagEnabled,
  isGuestSubmitOrderPending,
} from 'src/deps'
import {
  APPConfig,
  getLocalStorage,
  setLocalStorage,
  getSessionStorage,
} from 'config/appConfig'
import './styles.scss'
import { retrieveAccountTypeGroupKey } from 'src/utils/signUpUtils'
import {
  isEnableExpressCheckoutMemberAgreement,
  isEnableExpressCheckoutMemberAgreementForRegisteredUser,
  isEnableIronCladIntegrationAPI,
  isEnableMemberAgreementCheckout,
} from '../../Header/deps'
import SubscriptionAmountModal from '../../MultipleSubscriptionComponents/RecurringSubscriptionAmountModal/SubscriptionAmountModal'
import { CHECKOUT_PATHS } from 'src/views/pages/Checkout/fixture'

@observer
class SubmitOrder extends Component {
  static defaultProps = {
    enableSubmit: true,
  }
  @observable selectedDate = -1
  @observable endDate = -1
  @observable isValidDate = true
  @observable termsCheckboxChecked = false
  @observable submitDisableInfo = { isDisabled: false, message: '' }
  @observable disableSubmitForPaymentCrypt =
    convertToBoolean(APPConfig?.getAppConfig()?.disableSubmitForPaymentCrypt) ||
    false
  @observable showSubscriptionAmountModal = false
  klarnaTransactionStatusRefreshInterval
  klarnaTransactionTimeOut

  /**
   * @description Returns the appropriate payment container based on Paymetric flag
   * @returns {Object} tokenExContainer or paymetricContainer
   */
  getPaymentContainer = () => {
    const enableDirectPaymetricAndAccertifyIntegration = convertToBoolean(
      APPConfig.getAppConfig().enableDirectPaymetricAndAccertifyIntegration
    )
    return enableDirectPaymetricAndAccertifyIntegration
      ? paymetricContainer
      : tokenExContainer
  }

  isPaymetricEnabled = () => {
    return convertToBoolean(
      APPConfig.getAppConfig().enableDirectPaymetricAndAccertifyIntegration
    )
  }

  createSavedCardCvvContainer = () => {
    return this.isPaymetricEnabled()
      ? new PaymetricSavedCardCvvContainer()
      : new TokenExCvvContainer()
  }

  getPaypalContainerNode = () =>
    typeof document !== 'undefined'
      ? document.getElementById('paypal-container')
      : null

  markPaypalSubmitButtonInitStarted = () => {
    const container = this.getPaypalContainerNode()
    if (container?.dataset) {
      container.dataset.paypalInitStarted = 'true'
    }
  }

  canInitializePaypalSubmitButton = () => {
    const container = this.getPaypalContainerNode()
    if (!container) {
      return false
    }
    return (
      container.dataset?.paypalInitStarted !== 'true' &&
      this.props.enableSubmit &&
      paypalContainer.paypalInitiate &&
      typeof braintree !== 'undefined' &&
      braintree?.client
    )
  }

  initializePaypalSubmitButton = () => {
    if (!this.canInitializePaypalSubmitButton()) {
      return
    }

    //Paypal braintree
    const existingInstance =
      paypalContainer?.paypalCheckoutInstance || paypalContainer?.paypalInstance

    if (existingInstance) {
      this.markPaypalSubmitButtonInitStarted()
      paypalContainer?.createPaypalButton(existingInstance)
      return
    }

    if (paypalContainer.paypalClientCreated) {
      return
    }

    this.markPaypalSubmitButtonInitStarted()
    paypalContainer.paypalClientCreated = true
    braintree.client?.create(
      {
        authorization: this.props?.paypalToken,
      },
      function (clientErr, clientInstance) {
        if (clientErr || clientInstance === undefined) {
          paypalContainer.paypalClientCreated = false
        }
        paypalContainer.createPayPalCheckoutComponent(
          clientErr,
          clientInstance
        )
      }
    )
  }

  componentDidUpdate() {
    this.initializePaypalSubmitButton()
    if (!isExpressCheckout()) {
      paypalContainer.disablePaypalSDKButton()
    }
    //Venmo braintree
    if (
      this.props.enableSubmit &&
      venmoContainer.venmoInitiate &&
      typeof braintree !== 'undefined' &&
      braintree?.client &&
      !venmoContainer.venmoClientCreated
    ) {
      if (!this.props?.venmoToken && isExpressCheckout()) {
        this.props?.handleVenmoInitiate()
        return
      }
      braintree.client?.create(
        {
          authorization: this.props?.venmoToken,
        },
        function (clientErr, clientInstance) {
          venmoContainer.createVenmoCheckoutComponent(clientErr, clientInstance)
        }
      )
      // Added to prevent re-trigger of Venmo Client
      venmoContainer.venmoClientCreated = true
    }

    // Google Pay Client Initialization
    this.initializeGooglePayClient()

    //ApplePay BrainTree integration
    this.initApplePayClient()
    this.checkCartErrorsForPaymentCrypt()
  }

  componentDidMount() {
    checkoutContainer.activeSubmitOrderButton = true
    checkoutContainer.isToDisableSubmitOrderButton = false
    this._expressSubmitDisposer = reaction(
      () => checkoutContainer.triggerExpressSubmit,
      shouldSubmit => {
        if (shouldSubmit && isExpressCheckout()) {
          checkoutContainer.triggerExpressSubmit = false // reset for next use
          this.handleSubmitClick()
        }
      }
    )

    this._paymetricValidationDisposer = reaction(
      () => {
        const selectedPaymentType = (
          checkoutContainer.selectedPaymentType || ''
        ).toLowerCase()
        return {
          selectedPaymentType,
          paymetricError: paymetricContainer?.paymetricErrorData?.error,
          paymetricErrorSequence:
            paymetricContainer?.paymetricErrorData?.errorSequence,
          paymetricIsValid: paymetricContainer?.paymetricValidData?.isValid,
        }
      },
      snapshot => {
        const hasPaymetricValidationFailure =
          !!snapshot?.paymetricError || snapshot?.paymetricIsValid === false
        const isCreditCardPayment =
          snapshot?.selectedPaymentType === 'creditcard'

        if (
          isCreditCardPayment &&
          hasPaymetricValidationFailure &&
          isExpressCheckout()
        ) {
          this.resetSubmitOrderRetryState()
        }
      }
    )

    // Watch for payment method changes and sync button disable state in subscription override checkout
    // Track both selectedPaymentType AND submitBlockingErrorCode to catch error resolution
    // Add fireImmediately to handle page refresh with pre-selected payment
    this._paymentChangeDisposer = reaction(
      () => ({
        selectedPaymentType: checkoutContainer.selectedPaymentType,
        blockingErrorCode: checkoutContainer.submitBlockingErrorCode,
      }),
      ({ selectedPaymentType, blockingErrorCode }) => {
        // Only reset disable flags in subscription override checkout to avoid interfering with
        // legitimate disable states (e.g., EOPLOR001 error, terms not checked)
        if (
          isSubscriptionOverrideCheckoutPage() &&
          selectedPaymentType &&
          typeof selectedPaymentType === 'string' &&
          selectedPaymentType.length > 0 &&
          !blockingErrorCode &&
          !checkoutContainer.paymentDeletionInProgress
        ) {
          //  Wrap mutations in runInAction to batch updates and prevent render flicker
          runInAction(() => {
            this.submitDisableInfo.isDisabled = false
            this.submitDisableInfo.message = '' //  Clear stale error message
            checkoutContainer.isToDisableSubmitOrderButton = false
            checkoutContainer.activeSubmitOrderButton = true
          })
        }
      },
      { fireImmediately: true } // Fire on mount if payment already selected (page refresh scenario)
    )
  }

  componentWillUnmount() {
    // Dispose reaction to prevent memory leak and stale firing after unmount.
    if (this._expressSubmitDisposer) {
      this._expressSubmitDisposer()
      this._expressSubmitDisposer = null
    }
    if (this._paymetricValidationDisposer) {
      this._paymetricValidationDisposer()
      this._paymetricValidationDisposer = null
    }
    if (this._paymentChangeDisposer) {
      this._paymentChangeDisposer()
      this._paymentChangeDisposer = null
    }
    checkoutContainer.triggerExpressSubmit = false
    klarnaContainer.closeKlarnaWindow()
    klarnaContainer.clearKlarnaTransactionStatusTimer()
    klarnaContainer.isCloseWindowFromCallback = false
    klarnaContainer.klarnaBrowserPopupBlock = false
  }

  checkCartErrorsForPaymentCrypt = () => {
    if (
      cartContainer?.cartResponse?.errorCode === 'EOPLOR001' &&
      this.disableSubmitForPaymentCrypt
    ) {
      this.submitDisableInfo.isDisabled = true
      this.submitDisableInfo.message = i18nTranslate(
        'cart.homeMarket',
        'Please switch to your home market to make a purchase.'
      )
    } else if (
      cartContainer?.cartResponse?.errorCode === 'CustomerNotAllowed'
    ) {
      this.submitDisableInfo.isDisabled = true
    }
  }

  initApplePayClient = () => {
    if (
      this.props?.enableSubmit &&
      applepayContainer.applepayInitiate &&
      typeof braintree !== 'undefined' &&
      braintree?.client &&
      !applepayContainer.applepayClientCreated
    ) {
      braintree.client?.create(
        {
          authorization:
            this.props?.applepayToken || applepayContainer.applepayToken,
        },
        function (clientErr, clientInstance) {
          applepayContainer.initializeApplePayPayment(clientErr, clientInstance)
        }
      )
      // Added to prevent re-trigger the Client
      applepayContainer.applepayClientCreated = true
    }
  }

  /**
   * Initializes the Google Pay client for payment processing.
   */
  initializeGooglePayClient = () => {
    let googlePayProps = { isFromViewCart: false, isFromCheckout: true }
    if (
      this.props?.enableSubmit &&
      googlePayContainer.isToInitiateGooglePayPayment &&
      typeof braintree !== 'undefined' &&
      braintree?.client &&
      !googlePayContainer.googlePayClientCreated &&
      (this.props?.googlePayToken || googlePayContainer?.googlePayPaymentToken)
    ) {
      braintree.client?.create(
        {
          authorization:
            this.props?.googlePayToken ||
            googlePayContainer?.googlePayPaymentToken,
        },
        function (clientErr, clientInstance) {
          googlePayContainer.initiateGooglePayPayment(
            clientErr,
            clientInstance,
            googlePayProps
          )
        }
      )
      // Added to prevent re-trigger the Client
      googlePayContainer.googlePayClientCreated = true
    }
  }

  /**
   * Re-fetches Braintree client token when stale express GPay submit lost
   * in-memory token after cart refresh, then re-initializes the GPay client.
   * @returns {Promise<boolean>} true when client init was attempted
   */
  recoverStaleGooglePayClient = async () => {
    let token =
      this.props?.googlePayToken ||
      googlePayContainer?.googlePayPaymentToken ||
      ''

    if (!token) {
      const tokenResponse =
        await checkoutContainer.getBrainTreePaymentToken('GOOGLEPAY')

      if (!checkoutContainer.isSuccessResponse(tokenResponse)) {
        toastState.setToastMessage(
          tokenResponse?.message ||
            tokenResponse?.responseMessage ||
            i18nTranslate(
              'checkout.paymentGeneralError',
              'Sorry, we were unable to process your payment. Please try again.'
            ),
          false
        )
        return false
      }

      token = tokenResponse?.token || ''
      if (!token) {
        toastState.setToastMessage(
          i18nTranslate(
            'checkout.paymentGeneralError',
            'Sorry, we were unable to process your payment. Please try again.'
          ),
          false
        )
        return false
      }

      googlePayContainer.googlePayPaymentToken = token
    }

    googlePayContainer.isToInitiateGooglePayPayment = true
    googlePayContainer.isToEnableSubmitOrder = false
    googlePayContainer.googlePayClientCreated = false
    this.initializeGooglePayClient()
    return true
  }

  /**
   * Re-bootstraps the Apple Pay Braintree client when a stale submit lost the
   * in-memory token/instance after a cart refresh.
   * @returns {Promise<boolean>} true when client init was attempted
   */
  recoverStaleApplePayClient = async () => {
    let token =
      this.props?.applepayToken || applepayContainer?.applepayToken || ''

    if (!token) {
      const tokenResponse =
        await checkoutContainer.getBrainTreePaymentToken('APPLEPAY')

      if (!checkoutContainer.isSuccessResponse(tokenResponse)) {
        toastState.setToastMessage(
          tokenResponse?.message ||
            tokenResponse?.responseMessage ||
            i18nTranslate(
              'checkout.paymentGeneralError',
              'Sorry, we were unable to process your payment. Please try again.'
            ),
          false
        )
        return false
      }

      token = tokenResponse?.token || ''
      if (!token) {
        toastState.setToastMessage(
          i18nTranslate(
            'checkout.paymentGeneralError',
            'Sorry, we were unable to process your payment. Please try again.'
          ),
          false
        )
        return false
      }

      applepayContainer.applepayToken = token
    }

    applepayContainer.applepayInitiate = true
    applepayContainer.applepayClientCreated = false
    applepayContainer.submitOrderEnable = false
    this.initApplePayClient()
    return true
  }

  handleReviewOrder = () => {
    return checkoutContainer.reviewOrder()
  }

  handleDateChange = (date, event) => {
    event.preventDefault()
    this.selectedDate = date ? date.getTime() : -1
  }

  handleMaxDate = () => {
    const maxBackDatedOrder = new Date().setDate(new Date().getDate())
    this.endDate = maxBackDatedOrder
    return maxBackDatedOrder
  }

  //@todo need to handle if month is specific
  // handleMinDate = () => {
  //   const date = new Date()
  //   date.setDate(date.getDate() - 1)
  //   const monthTimeStamp = date.setMonth(date.getMonth() - 2)
  //   this.startDate = monthTimeStamp
  //   return monthTimeStamp
  // }

  handleBlur = event => {
    event.preventDefault()
    const currentSelectedDate = event.target.value
    const currentTimeStamp =
      currentSelectedDate && new Date(currentSelectedDate).getTime()
    if (currentTimeStamp <= this.endDate) {
      this.isValidDate = true
      this.selectedDate = currentTimeStamp
    } else {
      this.selectedDate = -1
      this.isValidDate = false
    }
  }

  /**
   * @description Condition to Enable/Disable Paypal Submit Order Button
   */
  isToDisablePaypalSubmitButton = () => {
    return paypalContainer.submitOrderEnable == false
      ? true
      : !this.props?.enableSubmit
        ? true
        : false
  }

  /**
   * @description Condition to Enable/Disable Venmo Submit Order Button
   */
  isToDisableVenmoSubmitButton = () => {
    return venmoContainer.submitOrderEnable == false
      ? true
      : !this.props?.enableSubmit
        ? true
        : false
  }

  /**
   * Determines whether the Google Pay submit button should be disabled.
   * @returns {boolean} - True if the Google Pay submit button should be disabled, false otherwise.
   */
  isToDisableGooglePaySubmitButton = () => {
    return !googlePayContainer.isToEnableSubmitOrder
      ? true
      : !this.props?.enableSubmit
  }

  /**
   * @description Condition to Enable/Disable ApplePay Submit Order Button
   */
  isToDisableApplePaySubmitButton = () => {
    return !applepayContainer.submitOrderEnable
      ? true
      : !this.props?.enableSubmit
  }

  handleLoading(isLoading) {
    if (isExpressCheckout() && !isLoading && this.props?.isFromPDP) {
      overlayState.isLoading = true
    }
    overlayState.toggleLoader()
    if (isLoading) document.body.classList.add('no-scroll')
    else document.body.classList.remove('no-scroll')
  }

  /**
   * @description Initiates Alipay checkout flow.
   * Checks for valid Alipay response and redirects to Alipay checkout URL if successful.
   * Handles error cases by reloading page or closing Alipay checkout overlay.
   * Logs user and browser details for debugging.
   */
  handleAlipaySubmitOrder = async () => {
    const userId = customerContainer?.userId || ''
    const paymentType =
      cartContainer?.cartResponse?.payments
        ?.map(item => {
          return item?.type || ''
        })
        ?.join(',') || ''
    const browserType = getBrowserType()
    trackErrorInInstana({
      errorReport: `Alipay User and Browser Details - Before Alipay Initiate API - UserId: ${userId}`,
      errorData: {
        browserName: browserType?.name || '',
        browserVersion: browserType?.version || '',
        cartType: cartContainer?.cartResponse?.cartType || '',
        paymentType: paymentType || '',
      },
    })
    customerContainer?.isRegisterUser &&
      (await sessionContainer.refreshSession())
    await checkoutContainer.addAlipayInitiate(window?.location?.href)
    if (
      checkoutContainer.alipayResponse.result === 'success' &&
      checkoutContainer?.alipayResponse?.result != undefined &&
      typeof window !== 'undefined'
    ) {
      setLocalStorage('isFromAlipayPayment', true)
      window.location.replace(`${checkoutContainer.alipayResponse.url}`)
      this.props.closeAlipayInitiate()
    } else {
      this.handleLoading(false)
      if (typeof window !== 'undefined' && IS_BROWSER) {
        window?.location?.reload()
      }
    }
  }
  /**
   * @description Initiates Klarna payment by calling initiateKlarnaPayment API.
   * Tracks errors using Instana.
   * On success, redirects to Klarna payment URL.
   * On failure, reloads page.
   */
  handleKlarnaSubmitOrder = async () => {
    const userId = customerContainer?.userId || ''
    const paymentType =
      cartContainer?.cartResponse?.payments
        ?.map(item => {
          return item?.type || ''
        })
        ?.join(',') || ''
    const browserType = getBrowserType()
    trackErrorInInstana({
      errorReport: `Klarna User and Browser Details - Before Klarna Initiate API - UserId: ${userId}`,
      errorData: {
        browserName: browserType?.name || '',
        browserVersion: browserType?.version || '',
        cartType: cartContainer?.cartResponse?.cartType || '',
        paymentType: paymentType || '',
      },
    })

    await klarnaContainer.handleKlarnaSubmitOrderV2({
      submitOrderBtnProps: this.props,
    })
  }

  handleOrdersMappingInStorage = async (
    orderSubmitResponse,
    globalPaymentInitiateResponse
  ) => {
    const paymentId =
      globalPaymentInitiateResponse?.transaction?.properties?.filter(
        item => item?.name === 'confirmationCode'
      )?.[0]?.value || ''
    const ordersMap = getLocalStorage('OrdersMapping')
    const updatedOrdersMap = {
      ...ordersMap,
      [paymentId]: orderSubmitResponse?.orderId || '',
    }
    setLocalStorage('OrdersMapping', updatedOrdersMap)
  }

  handlePurchaseEventTracking = () => {
    if (isINMarket()) {
      const gtmData = cartContainer?.cartResponse || {}
      setLocalStorage('purchaseEventDataForIN', JSON.stringify(gtmData))
      return
    }
    checkoutContainer.pushPathToPurchasePurchaseEvent()
  }

  /**
   * @description Initiates global payment and redirects to payment provider.
   *
   * Checks if user is registered and refreshes session.
   * If the GPS redesign flow flag is disabled, submits the order through the
   * standard flow with no GPS initiate call or redirect.
   * Otherwise calls checkoutContainer.initiateGlobalPayment method.
   * On success, tracks event and redirects to payment provider URL.
   * On failure, tracks event, sets checkoutContainer.isToInitiateGlobalPayment
   * to false, and sets checkoutContainer.activePath back to 'payment'.
   */
  handleGlobalPaymentSubmitOrder = async () => {
    customerContainer?.isRegisterUser &&
      (await sessionContainer.refreshSession())
    const isSubscriptionProductInCart = cartContainer.hasSubscriptionProduct()
    const domain = window?.location?.href || ''
    const isGpsRedesignFlowEnabled = this.getIsGpsRedesignFlowEnabled(
      isSubscriptionProductInCart
    )

    // Redesign flag off: submit normally, skip GPS initiate/redirect entirely.
    if (!isGpsRedesignFlowEnabled) {
      checkoutContainer.isToInitiateGlobalPayment = false
      const contextValue = checkMysiteOrPersonalOffer()
      await this.handleStandardSubmitOrder(undefined, contextValue)
      return
    }

    const globalPaymentInitiateResponse =
      await checkoutContainer.initiateGlobalPayment(
        domain,
        isSubscriptionProductInCart
      )

    /** Check if GPS initiate failed before calling submitOrder */
    if (!checkoutContainer.isSuccessResponse(globalPaymentInitiateResponse)) {
      this.handleGpsInitiateFailure(globalPaymentInitiateResponse)
      return
    }

    const orderSubmitResponse = await checkoutContainer.submitOrder()
    if (checkoutContainer.isSuccessResponse(orderSubmitResponse)) {
      await this.handleGpsOrderSuccess(
        orderSubmitResponse,
        globalPaymentInitiateResponse
      )
    } else {
      await this.handleGpsOrderFailure(orderSubmitResponse)
    }
  }

  /**
   * Resolves whether the GPS redesign flow is enabled for the current cart.
   */
  getIsGpsRedesignFlowEnabled = isSubscriptionProductInCart => {
    const gpsRedesignFlow = getGPSConfig('enableGPSRedesignFlow')
    const isGpsSubsRedesignFlow = getGPSConfig('enableGPSSubsRedesignFlow')
    return isSubscriptionProductInCart ? isGpsSubsRedesignFlow : gpsRedesignFlow
  }

  /**
   * Resets state after a failed GPS Initiate API call (before or after submitOrder).
   */
  handleGpsInitiateFailure = globalPaymentInitiateResponse => {
    trackErrorInInstana({
      errorReport: 'GPS Initiate API - Failure',
      errorData: globalPaymentInitiateResponse,
    })
    this.handleLoading(false)
    checkoutContainer.isToInitiateGlobalPayment = false
    checkoutContainer.activePath = CHECKOUT_PATHS.PAYMENT
    // Reset so the Submit button is not stuck disabled after GPS initiate/redirect failure.
    checkoutContainer.isToDisableSubmitOrderButton = false
  }

  /**
   * Handles a successful submitOrder response within the GPS redesign flow:
   * redirects to the payment provider on success, otherwise resets state.
   */
  handleGpsOrderSuccess = async (
    orderSubmitResponse,
    globalPaymentInitiateResponse
  ) => {
    setLocalStorage('orderSubmitResponseOrderId', orderSubmitResponse?.orderId)
    if (
      checkoutContainer.isSuccessResponse(globalPaymentInitiateResponse) &&
      typeof window !== 'undefined'
    ) {
      checkoutContainer.storeGTMDataInLocalStorage(
        globalPaymentInitiateResponse
      )
      await this.handleOrdersMappingInStorage(
        orderSubmitResponse,
        globalPaymentInitiateResponse
      )
      trackErrorInInstana({
        errorReport: 'GPS Initiate API - Success',
        errorData: globalPaymentInitiateResponse,
      })
      if (cartContainer.isRazorpayPayment()) {
        setLocalStorage('gpsRedirection', true)
      }
      this.handlePurchaseEventTracking()
      const globalPaymentRedirectionURL =
        globalPaymentInitiateResponse?.redirectUrl || ''
      window.location.replace(`${globalPaymentRedirectionURL}`)
      checkoutContainer.isToInitiateGlobalPayment = false
    } else {
      this.handleGpsInitiateFailure(globalPaymentInitiateResponse)
    }
  }

  /**
   * Handles a failed submitOrder response within the GPS redesign flow:
   * surfaces an error, deletes the payment, and cleans up a new SEPA payment if present.
   */
  handleGpsOrderFailure = async orderSubmitResponse => {
    const errorMessage =
      orderSubmitResponse?.errorMessage ||
      orderSubmitResponse?.message ||
      i18nTranslate('order.orderCancel', 'Your order has been cancelled.')
    // Capture before deletePayment() clears cartResponse.payments
    const sepaCartPayment = cartContainer?.cartResponse?.payments?.find(
      payment => isTwikeyPaymentName(payment?.name)
    )
    const isNewSepaPayment = !!sepaCartPayment && !!checkoutContainer.iBanValue
    await checkoutContainer.deletePayment()

    if (isNewSepaPayment) {
      await this.deleteSepaPaymentProfile(sepaCartPayment)
    }

    toastState.setToastMessage(errorMessage, false)
    overlayState.hideLoader()
    // Reset so the Submit button is not stuck disabled after submit order failure.
    checkoutContainer.isToDisableSubmitOrderButton = false
  }

  /**
   * Removes a SEPA payment from the customer's saved payment profile so the
   * IBAN/mandate isn't left registered after a failed order submission.
   */
  deleteSepaPaymentProfile = async sepaCartPayment => {
    try {
      const sepaPaymentId = sepaCartPayment?.accountInfo?.id
      if (sepaPaymentId) {
        await customerContainer.fetchResponse({
          endPointName: 'deletePayment',
          pathParams: `${sepaPaymentId}`,
        })
      }
    } catch (e) {
      console.error('Error deleting SEPA payment:', e)
      // silently ignore cleanup errors so the order failure flow continues
    }
  }

  /**
   * Redirects to the view cart page after a delay.
   * Sets a timeout to first call the viewCart method on the cartContainer,
   * then pushes the viewCart page route.
   */
  redirectToViewCart = () => {
    let isSubscriptionCheckout = isSubscriptionOverrideCheckoutPage() || false
    setTimeout(async () => {
      await cartContainer.viewCart()
      if (isSubscriptionCheckout) {
        this.props.history?.push(pageNames.subscriptionCart)
      } else {
        this.props.history?.push(pageNames.viewCart)
      }
    }, 1000)
  }

  handleExpressCheckoutCardError = async () => {
    overlayState.showLoader()
    const cardPayment =
      cartContainer?.cartResponse?.payments?.find(
        payment => payment?.type?.toLowerCase() === 'creditcard'
      ) || {}
    const tokenValue = cardPayment?.accountInfo?.token || ''
    const cardId = cardPayment?.accountInfo?.id || ''
    const cardProvider = cardPayment?.accountInfo?.provider || ''
    await checkoutContainer.deletePayment()
    checkoutContainer.expressPaymentAdded = false
    checkoutContainer.autoPaymentSuccess = false
    if (isFeatureEnabled('enableDirectPaymetricAndAccertifyIntegration')) {
      // Refresh the Paymetric iframe session on failure so the user can
      // resubmit with a fresh accessToken (single-use by Worldpay design).
      // for error during submit order in express checkout like INTL500
      await paymetricContainer.retryPaymetricSession()
      overlayState.hideLoader()
      return
    }
    const isAddNewPayment = document.getElementById('add-new-pay-save')
    if (isAddNewPayment) {
      await this.getPaymentContainer().getTokenExAuthKeyFromSFO()
    } else if (tokenValue) {
      const iframeLoaded = document.getElementById(
        `tx_iframe_cvvTokenID${cardId}`
      )
      if (iframeLoaded) {
        iframeLoaded.remove()
      }
      let tokenExUpdate = this.createSavedCardCvvContainer()
      tokenExUpdate.containerId = cardId || ''
      tokenExUpdate.errorValidationCallBack = (containerId, validData) => {
        const errorElement = document.querySelector(
          `#cvvParent${containerId} .cardCvvtoken`
        )
        if (validData.isValid == false) {
          errorElement?.classList?.add('show')
          this.savedCardValidStatus = false
          if (isExpressCheckout()) {
            document
              ?.getElementById(`cvvTokenID${containerId}`)
              ?.scrollIntoView({ block: 'center' })
            overlayState.hideLoader()
          }
        } else {
          errorElement?.classList?.remove('show')
          this.savedCardValidStatus = true
        }
      }
      tokenExUpdate?.loadTokenExCvvIframe(
        `cvvTokenID${cardId}`,
        tokenValue,
        cardProvider,
        cardPayment
      )
    }
    overlayState.hideLoader()
  }

  patchSubscriptionGroupNameToCart = async () => {
    //@todo - rs - Need to check normal submit order flow
    // Need to handle Failure scenarios

    // Get payment type from selectedPaymentType, fallback to cart response for saved payments (e.g., SEPA)
    let paymentType = checkoutContainer.selectedPaymentType

    if (!paymentType) {
      // Fallback: get payment type from the first payment in cart response for saved payments
      const payments = cartContainer?.cartResponse?.payments || []

      if (payments.length > 0) {
        paymentType = payments[0]?.type || ''
      }
    }

    const savedPayments = customerContainer?.paymentResponse?.payments || []
    // Prefer the card the user actually selected in the payment list; only fall
    // back to default/first when no explicit selection is available.
    const userSelectedSavedPaymentId =
      savedCardsContainer?.selectedSavedPaymentId || ''
    const selectedSavedPayment =
      savedPayments.find(
        payment => payment?.id === userSelectedSavedPaymentId
      ) ||
      savedPayments.find(payment => payment?.isDefault) ||
      savedPayments[0] ||
      {}

    if (!paymentType) {
      // Fallback for saved/default methods (for example PayU) when tab state isn't populated.
      const defaultSavedPayment = selectedSavedPayment
      paymentType = defaultSavedPayment?.name || defaultSavedPayment?.type || ''
    }

    if (
      !paymentType &&
      checkoutContainer.currentPaymentTypeTab === 'savedcards'
    ) {
      paymentType = 'creditcard'
    }

    const paymentContainer = this.getPaymentContainer()
    const isCreditCardPayment = paymentType?.toLowerCase() === 'creditcard'

    const gpsCreditCardOptions =
      checkoutContainer.globalPaymentResponse?.CREDITCARD || []
    const isPlainCvvSavedGPSCard = paymentName =>
      isExternalGPSCreditCardPaymentName(paymentName, gpsCreditCardOptions)
    const isSavedCardsTab =
      checkoutContainer.currentPaymentTypeTab === 'savedcards'
    const isPlainCvvSavedGPSCardSelected =
      isSavedCardsTab &&
      (isPlainCvvSavedGPSCard(paymentType) ||
        isPlainCvvSavedGPSCard(selectedSavedPayment?.name))
    if (
      isCreditCardPayment &&
      !this.isPaymetricEnabled() &&
      !isPlainCvvSavedGPSCardSelected
    ) {
      const tokenExValidity = paymentContainer?.tokenExValidData || {}
      const hasValidationError =
        tokenExValidity?.isValid === false ||
        tokenExValidity?.isCvvValid === false

      if (hasValidationError) {
        this.resetSubmitOrderRetryState()
        overlayState.hideLoader()
        const section = document.querySelector('[class="token-block"]')
        section?.scrollIntoView({ behavior: 'smooth', block: 'end' })
        return false
      }
    }

    const bagValue = Math.abs(
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid || ''
    )

    if (!this.validateSepaIbanBeforeSubmit()) {
      this.resetSubmitOrderRetryState()
      overlayState.hideLoader()
      return false
    }
    if (
      (paymentType?.toLowerCase() != 'creditcard' ||
        isPlainCvvSavedGPSCardSelected) &&
      bagValue > 0
    ) {
      if (!paymentType) {
        toastState.setToastMessage(
          i18nTranslate(
            'payment.methodNotSelected',
            'Payment method not properly selected. Please select a payment method and try again.'
          ),
          false
        )
        this.resetSubmitOrderRetryState()
        overlayState.hideLoader()
        return false
      }
      overlayState.showLoader()
      const gpsPaymentList = checkoutContainer.globalPaymentResponse || {}
      // Only the legacy 'Twikey' record name needs remapping; a SEPA option
      // keeps its GPS key so the GPS options lookup still resolves.
      const selectedPaymentType = isLegacyTwikeyPaymentName(paymentType)
        ? SEPA
        : paymentType
      let unpaidPaymentResponse
      // handleUnpaidPayment -> addAlternatePayment already shows its own
      // failure toast (e.g. duplicate payment), so skip the redundant one below.
      let hasSelfToastedOnFailure = false

      // The generic 'sepa' identifier is shared by a brand-new (not-yet-saved)
      // SEPA entry and by saved records named 'SEPA', so a saved card is
      // detected from the user's selected saved payment (see
      // getSelectedSavedSepaCard) rather than from the type string alone.
      // A record literally named 'Twikey' is always a saved payment.
      const savedSepaCard = this.getSelectedSavedSepaCard()
      const isSavedSepaCardSelected =
        isLegacyTwikeyPaymentName(paymentType) || !!savedSepaCard

      if (isSavedSepaCardSelected) {
        // For Saved SEPA payment — used addPaymentsToCart to pass paymentRefId
        if (!savedSepaCard) {
          this.resetSubmitOrderRetryState()
          toastState.setToastMessage(
            i18nTranslate(
              'payment.savedSepaNotFound',
              'Unable to find saved SEPA payment. Please re-select your payment and try again.'
            ),
            false
          )
          overlayState.hideLoader()
          return false
        }
        unpaidPaymentResponse = await checkoutContainer.addPaymentsToCart({
          ...savedSepaCard,
          isFromSavedAddress: true,
          tokenExData: {},
        })
      } else if (isPlainCvvSavedGPSCardSelected) {
        // Prefer the GPS card the user actually selected; fall back to the
        // default/first GPS card only when no valid selection is present.
        const selectedGpsId = savedCardsContainer?.selectedSavedPaymentId || ''
        const savedPlainCvvGPSCard =
          savedPayments.find(
            payment =>
              payment?.id === selectedGpsId &&
              isPlainCvvSavedGPSCard(payment?.name)
          ) ||
          savedPayments.find(
            payment =>
              payment?.isDefault && isPlainCvvSavedGPSCard(payment?.name)
          ) ||
          savedPayments.find(payment =>
            isPlainCvvSavedGPSCard(payment?.name)
          ) ||
          {}
        if (!savedPlainCvvGPSCard?.id) {
          checkoutContainer.isToDisableSubmitOrderButton = false
          toastState.setToastMessage(
            i18nTranslate(
              'payment.savedCardNotFound',
              'Unable to find saved payment. Please re-select your payment and try again.'
            ),
            false
          )
          overlayState.hideLoader()
          return false
        }
        unpaidPaymentResponse = await checkoutContainer.addPaymentsToCart({
          ...savedPlainCvvGPSCard,
          isFromSavedAddress: true,
          tokenExData: savedCardsContainer.tokenExCvvData,
        })
        if (checkoutContainer.isSuccessResponse(unpaidPaymentResponse)) {
          checkoutContainer.isToInitiateGlobalPayment = true
        }
      } else {
        unpaidPaymentResponse = await checkoutContainer.handleUnpaidPayment(
          selectedPaymentType,
          bagValue,
          gpsPaymentList
        )
        hasSelfToastedOnFailure = true
      }

      if (!checkoutContainer.isSuccessResponse(unpaidPaymentResponse)) {
        this.resetSubmitOrderRetryState()
        if (!hasSelfToastedOnFailure) {
          toastState.setToastMessage(
            unpaidPaymentResponse.message || unpaidPaymentResponse?.errorMessage
          )
        }
        overlayState.hideLoader()
        return false
      }
    }
    if (
      accountsContainer.showIroncladCheckbox &&
      accountsContainer.isMemberAgreementChecked &&
      isEnableIronCladIntegrationAPI() &&
      ((window?.location?.pathname?.includes(pageNames.checkout) &&
        isEnableMemberAgreementCheckout()) ||
        isEnableExpressCheckoutMemberAgreement() ||
        (window?.location?.pathname?.includes(pageNames.expressCheckout) &&
          isEnableExpressCheckoutMemberAgreementForRegisteredUser()))
    ) {
      const sid = APPConfig?.getAppConfig()?.ironCladSiteAccessId
      const sig = customerContainer?.profileResponse?.referenceAttribute || ''
      if (!this._postAgreedTermCalled) {
        this._postAgreedTermCalled = true
        postAgreedTerm(
          sid,
          sig,
          accountsContainer.isMemberAgreementCheckedData?.published_version,
          accountsContainer.isMemberAgreementCheckedData?.contractKey
        )
        accountsContainer.showIroncladCheckbox = false
      }
    }

    // For GPS credit card: GlobalPaymentAccordion sets to trigger gpsInitiate call
    if (isCreditCardPayment) {
      const isGPSPayment = (cartContainer?.cartResponse?.payments || []).some(
        payment =>
          isExternalGPSCreditCardPaymentName(
            payment?.name,
            gpsCreditCardOptions
          )
      )
      if (isGPSPayment) {
        checkoutContainer.isToInitiateGlobalPayment = true
      }
    }

    const isMultipleSubscriptionEnabled =
      isMultipleSubscriptionFlagEnabled() || false
    const isUserHasSubscriptionProductInCart =
      cartContainer.hasSubscriptionProduct() || false
    const unProcessableRequestMessage = i18nTranslate(
      'cart.unableToProcessMessage',
      'We are currently unable to process your request or it may already be processed. Please refresh your screen and try again'
    )
    const accountIssueMessage = i18nTranslate(
      'cart.addCartFailure',
      'There is an issue with your account. Please contact you local account manager.'
    )
    const somethingWentWrongMessage = i18nTranslate(
      'subscription.somethingwentwrong',
      'Sorry, something went wrong. Please try again.'
    )
    if (isMultipleSubscriptionEnabled && isUserHasSubscriptionProductInCart) {
      let updateResponse =
        await multipleSubscriptionContainer.updateSubscriptionGroupName()
      if (multipleSubscriptionContainer.isSuccessResponse(updateResponse)) {
        // await cartContainer.viewCart()
        await this.handleSubmitOrder(this.selectedDate)
      } else {
        checkoutContainer.isToDisableSubmitOrderButton = true
        let code = updateResponse?.code || updateResponse?.errorCode
        if (code === 'AOACHLD0001') {
          toastState.setToastMessage(i18nTranslate(accountIssueMessage), false)
        } else if (code === 'EOCACG0001') {
          toastState.setToastMessage(unProcessableRequestMessage, false)
        } else {
          toastState.setToastMessage(somethingWentWrongMessage, false)
        }
        checkoutContainer.activePath = CHECKOUT_PATHS.PAYMENT
      }
    } else {
      await this.handleSubmitOrder(this.selectedDate)
    }
  }

  /**
   * @description Scrolls to and focuses the IBAN input so its validation
   * message becomes visible.
   * @returns {boolean} true when the IBAN input exists on the page.
   */
  focusIbanInputWithScroll = () => {
    const ibanInput = document.getElementById('iban-input')
    ibanInput?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    ibanInput?.focus?.()
    // Trigger onBlur handler so validation message becomes visible.
    ibanInput?.blur?.()
    ibanInput?.focus?.()
    return !!ibanInput
  }

  /**
   * @description Returns the saved SEPA payment the user selected in the
   * payment list, or null when a new (not-yet-saved) SEPA entry is in use.
   * Saved SEPA records come back named either 'Twikey' or 'SEPA', and the
   * selected payment type is the lower-cased record name, so a saved 'SEPA'
   * record shares the 'sepa' type with the new-entry flow. The selected saved
   * payment id is what tells the two apart. A record literally named 'Twikey'
   * keeps the legacy fallback to the first saved SEPA record.
   * @returns {Object|null} saved SEPA payment record
   */
  getSelectedSavedSepaCard = () => {
    const selectedType = (checkoutContainer.selectedPaymentType || '')
      .toString()
      .trim()
      .toLowerCase()
    if (!isTwikeyPaymentName(selectedType)) {
      return null
    }

    const savedPayments = customerContainer?.paymentResponse?.payments || []
    const selectedSepaId = savedCardsContainer?.selectedSavedPaymentId || ''
    const selectedSavedSepaCard = selectedSepaId
      ? savedPayments.find(
          p => p?.id === selectedSepaId && isTwikeyPaymentName(p?.name)
        )
      : null
    if (selectedSavedSepaCard) {
      return selectedSavedSepaCard
    }

    if (isLegacyTwikeyPaymentName(selectedType)) {
      return savedPayments.find(p => isTwikeyPaymentName(p?.name)) || null
    }
    return null
  }

  validateSepaIbanBeforeSubmit = () => {
    // Get payment type from selectedPaymentType, fallback to cart response for saved payments
    let paymentType = checkoutContainer.selectedPaymentType?.toLowerCase()
    if (!paymentType) {
      const payments = cartContainer?.cartResponse?.payments || []
      // LOYALTY/STORECREDIT ride along with the real payment, so they must not
      // win the fallback and mask a SEPA entry.
      const chargeablePayment =
        payments.find(payment => {
          const type = (payment?.type || '').toUpperCase()
          return type !== 'LOYALTY' && type !== 'STORECREDIT'
        }) || payments[0]
      paymentType = chargeablePayment?.type?.toLowerCase() || ''
    }

    // The mounted IBAN input is the authoritative signal for a new SEPA entry:
    // several express-checkout handlers rewrite selectedPaymentType (saved-card
    // selection, tab switch, handleSubmitState) while the input is still shown.
    const isNewSepaIbanEntry = checkoutContainer.isSepaIbanEntryActive === true

    if (!isNewSepaIbanEntry && !isSepaPaymentType(paymentType)) {
      return true
    }

    // A saved SEPA payment already has its IBAN (and mandate) on file; the
    // IBAN input validation state only applies to a new SEPA entry, and a
    // 'Twikey' selection is always a saved record.
    if (
      !isNewSepaIbanEntry &&
      (isLegacyTwikeyPaymentName(paymentType) || this.getSelectedSavedSepaCard())
    ) {
      return true
    }

    const iBanValidationStatus = checkoutContainer.iBanValidationStatus || {}
    const hasValidationError =
      typeof iBanValidationStatus?.hasError === 'boolean'
        ? iBanValidationStatus.hasError
        : !(checkoutContainer.iBanValue || '').replace(/\s+/g, '')
    const isValid = !hasValidationError

    if (!isValid) {
      const hasIbanInput = this.focusIbanInputWithScroll()
      // Without the input there is no inline message, so surface the failure
      // instead of returning silently.
      if (!hasIbanInput) {
        toastState.setToastMessage(
          i18nTranslate(
            'payment.ibanRequired',
            'Please enter a valid IBAN or select a saved SEPA payment to continue.'
          ),
          false
        )
      }
    }

    return isValid
  }

  /**
   * @description Initiates Submit Order flow.
   * Calls submitOrder API on checkoutContainer.
   * On success, redirects to Order Confirmation Page.
   * On failure, throws proper error message based on errorCode.
   * Logs events and data for debugging.
   */
  /**
   * @description For Express Checkout with saved credit card, clicks the hidden
   * "add payment" button so its submit flow re-invokes handleSubmitOrder.
   * Returns true when handleSubmitOrder should return early.
   */
  handleExpressCreditCardAutoSubmit = () => {
    if (
      !isExpressCheckout() ||
      checkoutContainer.selectedPaymentType.toUpperCase() !== 'CREDITCARD'
    ) {
      return false
    }

    if (
      !checkoutContainer.autoPaymentSuccess &&
      !checkoutContainer.expressPaymentAdded
    ) {
      checkoutContainer.enableAutoSubmit = true
      const handlePaymentElement =
        document.getElementById('payment-continue-button') ||
        document.getElementById('add-new-pay-save')
      if (handlePaymentElement) {
        handlePaymentElement.click()
        return true
      }
    }
    checkoutContainer.isToDisableSubmitOrderButton = true
    return false
  }

  /**
   * @description Detects a stale Express Google Pay submit (payment already
   * on cart but the client wasn't (re)initiated) and recovers or retries it.
   * Returns true when handleSubmitOrder should return early.
   */
  handleStaleGooglePaySubmit = async () => {
    const selectedPaymentType = (
      checkoutContainer.selectedPaymentType || ''
    ).toLowerCase()
    const hasGooglePayPaymentInCart =
      cartContainer?.cartResponse?.payments?.some(
        payment =>
          (payment?.type || payment?.name)?.toLowerCase?.() === 'googlepay'
      ) || false
    const isStaleGooglePaySubmit =
      isExpressCheckout() &&
      selectedPaymentType === 'googlepay' &&
      hasGooglePayPaymentInCart &&
      !googlePayContainer.isToInitiateGooglePayPayment

    if (!isStaleGooglePaySubmit) {
      return false
    }

    overlayState.hideLoader()
    const isExpressGooglePayClientReady =
      googlePayContainer.googlePaymentInstance &&
      googlePayContainer.expressPaymentClient
    if (!isExpressGooglePayClientReady) {
      overlayState.showLoader()
      const recovered = await this.recoverStaleGooglePayClient()
      overlayState.hideLoader()

      if (!recovered) {
        checkoutContainer.isToDisableSubmitOrderButton = true
        checkoutContainer.activeSubmitOrderButton = false
        return true
      }

      checkoutContainer.activeSubmitOrderButton = true
      checkoutContainer.isToDisableSubmitOrderButton = false
      toastState.setToastMessage(
        i18nTranslate(
          'checkout.googlePayRetrySubmit',
          'Google Pay is ready. Please click Submit Order again.'
        ),
        false
      )
      return true
    }

    checkoutContainer.activeSubmitOrderButton = true
    checkoutContainer.isToDisableSubmitOrderButton = false
    await googlePayContainer.handleGooglePaySubmitButtonClick(this.props)
    return true
  }

  /**
   * @description Detects a stale Apple Pay submit (applepay payment still on
   * the cart but applepayInitiate was reset, e.g. after a cart refresh on a
   * bundle + SKU GPS cart) and re-surfaces the Apple Pay button so the user
   * re-authorizes instead of submitting nonce-less (BT_NONCE_NULL).
   * Returns true when handleStandardSubmitOrder should return early.
   */
  handleStaleApplePaySubmit = async () => {
    const selectedPaymentType = (
      checkoutContainer.selectedPaymentType || ''
    ).toLowerCase()
    const hasApplePayPaymentInCart =
      cartContainer?.cartResponse?.payments?.some(
        payment =>
          (payment?.type || payment?.name)?.toLowerCase?.() === 'applepay'
      ) || false
    const isStaleApplePaySubmit =
      selectedPaymentType === 'applepay' &&
      hasApplePayPaymentInCart &&
      !applepayContainer.applepayInitiate

    if (!isStaleApplePaySubmit) {
      return false
    }

    overlayState.hideLoader()
    if (!applepayContainer.submitOrderEnable) {
      overlayState.showLoader()
      const recovered = await this.recoverStaleApplePayClient()
      overlayState.hideLoader()

      if (!recovered) {
        checkoutContainer.isToDisableSubmitOrderButton = true
        checkoutContainer.activeSubmitOrderButton = false
        return true
      }
    } else {
      // Apple requires a user gesture to open a sheet, so the only safe
      // recovery is re-rendering the Apple Pay button for a fresh tap.
      applepayContainer.applepayInitiate = true
    }

    checkoutContainer.activeSubmitOrderButton = true
    checkoutContainer.isToDisableSubmitOrderButton = false
    toastState.setToastMessage(
      i18nTranslate(
        'checkout.applePayRetrySubmit',
        'Apple Pay is ready. Please click Submit Order again.'
      ),
      false
    )
    return true
  }

  buildCheckoutShipmentInfo = orderPlacedDetail => ({
    firstName: orderPlacedDetail?.firstName || '',
    email: orderPlacedDetail?.email || '',
    address:
      orderPlacedDetail?.addressLine1 && orderPlacedDetail?.addressLine2
        ? orderPlacedDetail?.addressLine1 + orderPlacedDetail?.addressLine2
        : '',
    phoneNumber: orderPlacedDetail?.phone || '',
    city:
      orderPlacedDetail?.city && orderPlacedDetail?.phone
        ? orderPlacedDetail?.city + orderPlacedDetail?.phone
        : '',
    state: orderPlacedDetail?.state || '',
    zipCode: orderPlacedDetail?.zip || '',
  })

  buildCheckoutAccountInfo = gtmData => ({
    name:
      gtmData?.payments?.[0]?.accountInfo?.name &&
      gtmData?.payments?.[0]?.accountInfo?.lastname
        ? gtmData?.payments?.[0]?.accountInfo?.name +
          gtmData?.payments?.[0]?.accountInfo?.lastname
        : '',
    card: gtmData?.payments?.[0]?.accountInfo?.provider || '',
    loginUser: gtmData?.userName || '',
  })

  trackSubmitOrderPurchaseEvents = ({
    gtmData,
    contextValue,
    chekoutShipmentInfo,
    checkoutAccountInfo,
    enableEQFastFollow,
    userTypeSponsorId,
    guestSignupOrigin,
  }) => {
    trackGTMEvents({
      event: 'CheckoutPurchaseButtonClicked',
      ecommerce: {
        purchase: {
          actionField: {
            id: checkoutContainer.orderId, //transaction id
            affiliation: 'Online Store',
            revenue: gtmData?.properties?.oneTimeItemsTotal || 0, // Total transaction value (incl. tax and shipping)
            tax: gtmData?.value?.overAllTax || '',
            shipping: gtmData?.value?.cartDeliveryCharge || '',
            coupon: gtmData?.promotionDetails?.codes?.[0]?.code || '',
          },
          products: getCheckoutProduct(gtmData?.items),
        },
      },
    })

    let gtmOrderType = gtmData?.properties?.orderType || 'Standard'
    if (contextValue === 'storefront') {
      gtmOrderType = 'Group offers'
    } else if (contextValue === 'personal_offer') {
      gtmOrderType = 'Personal offers'
    }

    const actionField = {
      id: checkoutContainer.orderId,
      memberId: gtmData?.userId || '',
      orderType: gtmOrderType,
      affiliation: 'Online Store',
      revenue: gtmData?.properties?.oneTimeItemsTotal || 0,
      tax: gtmData?.value?.overAllTax || '',
      shipping: gtmData?.value?.cartDeliveryCharge || '',
      coupon: gtmData?.promotionDetails?.codes?.[0]?.code || '',
      action: 'purchase',
      ...(isLATAM() && {
        payment_tier: gtmData?.payments?.[0]?.type || '',
        shipping_tier:
          gtmData?.deliveryDetails?.methods?.find(m => m?.isSelected)?.id || '',
      }),
    }
    if (enableEQFastFollow) {
      actionField.sponsor_id = userTypeSponsorId || ''
      actionField.origin = guestSignupOrigin || ''
    }
    if (!enableNewFeature('enableCheckoutPurchaseGTMEvent')) {
      trackGTMEvents({
        event: 'checkout-purchase',
        ecommerce: {
          currencyCode: gtmData?.currencyCode || '',
          purchase: {
            actionField: { ...actionField },
            products: getCheckoutProduct(gtmData?.items),
          },
        },
      })
    }

    const isCartHadSubscriptionProducts =
      gtmData?.items?.some(item => item.isSubscription === true) || false
    const multipleSubscriptionEnabled =
      isMultipleSubscriptionFlagEnabled() || false
    const subscriptionEnabled =
      multipleSubscriptionEnabled || isFlexibleSubscriptionFlagEnabled()

    if (isCartHadSubscriptionProducts && subscriptionEnabled) {
      trackGTMEvents({
        event: 'subscriptionPurchase',
        ecommerce: {
          currencyCode: gtmData?.currencyCode || '',
          purchase: {
            actionField: {
              id: checkoutContainer.orderId,
              memberId: gtmData?.userId || '',
              orderType: 'Subscription' || '',
              affiliation: 'Online Store',
              revenue: gtmData?.properties?.subsctiptionItemsTotal || 0,
              tax: gtmData?.value?.overAllTax || '',
              shipping: gtmData?.value?.cartDeliveryCharge || '',
              coupon: gtmData?.promotionDetails?.codes?.[0]?.code || '',
              action: 'purchase',
            },
            products: getCheckoutProductV2(gtmData),
          },
        },
      })
    }

    TagManager.dataLayer({
      dataLayer: {
        event: 'checkoutSubmitOrderInfo',
        ...getCheckoutGTMPageData(),
        firstName: chekoutShipmentInfo?.firstName || '',
        email: chekoutShipmentInfo?.email || '',
        address: chekoutShipmentInfo?.address || '',
        phone: chekoutShipmentInfo?.phoneNumber || '',
        city: chekoutShipmentInfo?.city || '',
        state: chekoutShipmentInfo?.state || '',
        zipCode: chekoutShipmentInfo?.zipCode || '',
        cardUser: checkoutAccountInfo?.name || '',
        cardType: checkoutAccountInfo?.card || '',
        loginUserName: checkoutAccountInfo?.loginUser || '',
        productCartType: gtmData?.cartType || '',
        totalPrice: gtmData?.currencySign + gtmData?.value?.grandTotal || '',
        discount: gtmData?.currencySign + gtmData?.value?.totalDiscount || '',
        deliveryCharge:
          gtmData?.currencySign +
            gtmData?.value?.cartDeliveryChargeAfterDiscount || '',
        platform: 'equinox',
      },
    })
  }

  handleSubmitOrderSuccess = async ({
    gtmData,
    contextValue,
    chekoutShipmentInfo,
    checkoutAccountInfo,
    enableEQFastFollow,
    userTypeSponsorId,
    guestSignupOrigin,
  }) => {
    toastState.setToastMessage(
      i18nTranslate('order.submitSuccess', 'Your order has been submitted.'),
      true
    )
    this.handlePurchaseEventTracking()
    cartContainer.clearCartCount()
    const isNativeApp = checkIsNativeApp() || false
    if (isNativeApp) {
      this.props.history?.push(
        `${pageNames.orderConfirmation}?isNativeApp=true`
      )
    } else {
      this.props.history?.push(`${pageNames.orderConfirmation}`)
    }
    await cartContainer.viewCart()
    await loyaltyContainer.getLoyaltyPoints(true)
    checkoutContainer.activeSubmitOrderButton = true
    // CX32-7032 - QUALTRICS - After placing order, delete 'shop-cart' value from local storage
    deleteFromLocalStorage('shop-cart')
    // GMS-10091 - After placing order, delete 'personalOffer_v2' value from local storage
    trackErrorInInstana({
      errorReport: 'Removed personalOffer_v2 from localStorage ',
      errorData: { personalOffer_v2: getLocalStorage('personalOffer_v2') },
    })
    deleteFromLocalStorage('personalOffer_v2')

    this.trackSubmitOrderPurchaseEvents({
      gtmData,
      contextValue,
      chekoutShipmentInfo,
      checkoutAccountInfo,
      enableEQFastFollow,
      userTypeSponsorId,
      guestSignupOrigin,
    })
  }

  checkSubmitOrderBackorderedItems = submitOrderResponse => {
    submitOrderResponse?.['items']?.forEach(item => {
      item &&
        item['skus'] &&
        item['skus'].map(bundleitem => {
          const inventoryProperties = bundleitem.inventoryProperties
          // backOrdered is always true, false, or null/undefined, so only availability matters
          const isUnavailable = inventoryProperties?.['available'] === false
          if (isUnavailable) {
            toastState.setToastMessage(
              i18nTranslate(
                'checkout.backorder',
                'Sorry, this item is on backorder or out of stock.'
              ),
              false
            )
            this.redirectToViewCart()
          }
        })
      checkoutContainer.isToDisableSubmitOrderButton = false
    })
  }

  handleSubmitOrderFailure = async (
    submitOrderResponse,
    chekoutShipmentInfo
  ) => {
    const errorCodes = [
      'INTL400',
      'INTL401',
      'INTL402',
      'INTL403',
      'INTL404',
      'INTL500',
    ]
    const acceritifyErrorCodes = [
      'ECPREATY0001',
      'ECPOSTATY0001',
      'ECPTC0001',
      'PYMT_ACCERTIFY_CLIENT_ERROR',
      'PYMT_ACCERTIFY_COMMON_ERROR',
      'PYMT_ACCERTIFY_400',
    ]

    overlayState.hideLoader()
    if (isExpressCheckout()) {
      checkoutContainer.activeSubmitOrderButton = true
      await this.handleExpressCheckoutCardError()
    }
    this.checkSubmitOrderBackorderedItems(submitOrderResponse)

    if (submitOrderResponse?.code === 'ECAPF0001') {
      toastState.setToastMessage(
        i18nTranslate(
          'order.paymentFraudCheck',
          'Sorry, your payment information failed. Please try a different payment method.'
        ),
        false
      )
      TagManager.dataLayer({
        dataLayer: {
          event: 'checkoutSubmitOrderErrorStatus',
          ...getCheckoutGTMPageData(),
          firstName: chekoutShipmentInfo?.firstName || '',
          email: chekoutShipmentInfo?.email || '',
          status: submitOrderResponse?.status,
          ErrorMsg:
            'Sorry, your payment information failed. Please try a different payment method.',
        },
      })
    } else if (
      submitOrderResponse?.code?.toLowerCase() ===
      'validation.subscription.name.exists'
    ) {
      const errorMessage =
        i18nTranslate(
          'subscriptionManageHeader.subscriptionNameEditModal.subscriptionNameAlreadyExistsToasterMessage',
          'Subscription Name already exists',
          { isNextGenTranslations: true }
        ) ||
        submitOrderResponse?.message ||
        submitOrderResponse?.responseMessage
      toastState.setToastMessage(errorMessage, false)
      TagManager.dataLayer({
        dataLayer: {
          event: 'checkoutSubmitOrderErrorStatus',
          ...getCheckoutGTMPageData(),
          firstName: chekoutShipmentInfo?.firstName || '',
          email: chekoutShipmentInfo?.email || '',
          status: submitOrderResponse?.status,
          ErrorMsg: errorMessage,
        },
      })
    } else if (
      submitOrderResponse?.code === 'EOCA0000011' ||
      submitOrderResponse?.errorCode === 'EOCA0000011'
    ) {
      /**
       * @info
       * 2 Error scenarios handled here for Out Of Stock and Expired Promotion as error code is same for both.
       * Translations Added based on the comparison of error messages
       */
      const errorMessage =
        submitOrderResponse?.message || submitOrderResponse?.responseMessage
      toastState.setToastMessage(
        alertMessageKeys(
          errorMessage,
          submitOrderResponse?.code || submitOrderResponse?.errorCode
        ) ||
          i18nTranslate(
            'order.outOfStock',
            'Few items in the cart are currently Out of Stock. Please check and update your cart to proceed.'
          ),
        false
      )
      this.redirectToViewCart()
    } else if (
      submitOrderResponse?.code === 'EOCA0000013' ||
      submitOrderResponse?.errorCode === 'EOCA0000013'
    ) {
      toastState.setToastMessage(
        i18nTranslate('cart.outOfStock', 'Out of Stock'),
        false
      )
      this.redirectToViewCart()
    } else if (submitOrderResponse?.code === 'ECBTE0001') {
      const errorMessage =
        submitOrderResponse?.message ||
        submitOrderResponse?.responseMessage ||
        i18nTranslate(
          'order.generalError',
          'Sorry, we are unable to place order. Please try again.'
        )
      toastState.setToastMessage(errorMessage)
      checkoutContainer.activePath = CHECKOUT_PATHS.PAYMENT
    } else if (acceritifyErrorCodes?.includes(submitOrderResponse?.code)) {
      const errorMessage =
        submitOrderResponse?.message ||
        i18nTranslate(
          'order.generalError',
          'Sorry, we are unable to place order. Please try again.'
        )
      toastState.setToastMessage(errorMessage)
      TagManager.dataLayer({
        dataLayer: {
          event: 'checkoutSubmitOrderErrorStatus',
          ...getCheckoutGTMPageData(),
          firstName: chekoutShipmentInfo?.firstName || '',
          email: chekoutShipmentInfo?.email || '',
          status: submitOrderResponse?.status || '',
          ErrorMsg: submitOrderResponse?.message || '',
        },
      })
      checkoutContainer.activePath = CHECKOUT_PATHS.PAYMENT
    } else if (
      errorCodes.indexOf(submitOrderResponse?.code?.split?.('_')?.[0]) !== -1
    ) {
      const errorMessage =
        submitOrderResponse?.message ||
        submitOrderResponse?.responseMessage ||
        i18nTranslate(
          'order.generalError',
          'Sorry, we are unable to place order. Please try again.'
        )
      toastState.setToastMessage(
        alertMessageKeys(
          errorMessage,
          submitOrderResponse?.code?.split?.('_')?.[0]
        )
      )
      checkoutContainer.activePath = CHECKOUT_PATHS.PAYMENT
    } else if (
      submitOrderResponse?.message ||
      submitOrderResponse?.errorMessage
    ) {
      toastState.setToastMessage(
        submitOrderResponse?.message || submitOrderResponse?.errorMessage
      )
    } else {
      toastState.setToastMessage(
        i18nTranslate(
          'order.generalError',
          'Sorry, we are unable to place order. Please try again.'
        ),
        false
      )
      TagManager.dataLayer({
        dataLayer: {
          event: 'checkoutSubmitOrderStatus',
          ...getCheckoutGTMPageData(),
          firstName: chekoutShipmentInfo?.firstName || '',
          email: chekoutShipmentInfo?.email || '',
          status: submitOrderResponse?.status,
          ErrorMsg: submitOrderResponse?.message,
        },
      })
    }
    checkoutContainer.activeSubmitOrderButton = isExpressCheckout() || false
  }

  shouldSkipGPSInitiateForCSRActOnBehalf = () => {
    if (!isCSRActOnBehalfSession()) {
      return false
    }

    // Paymetric 3DS only governs the GPS credit card flow. Other GPS payments
    // (Klarna, Bancontact, etc.) must still trigger gpsInitiate for CSR.
    const gpsCreditCardOptions =
      checkoutContainer.globalPaymentResponse?.CREDITCARD || []

    const hasGPSCreditCardPayment = (
      cartContainer?.cartResponse?.payments || []
    ).some(payment =>
      isExternalGPSCreditCardPaymentName(payment?.name, gpsCreditCardOptions)
    )

    if (!hasGPSCreditCardPayment) {
      return false
    }

    const validProcessorObj =
      checkoutContainer.getValidGPSCreditCardProcessor?.()
    return isPaymetric3DSProcessor(validProcessorObj)
  }

  handleStandardSubmitOrder = async (dateTimeStamp, contextValue) => {
    if (await this.handleStaleGooglePaySubmit()) {
      return
    }

    if (await this.handleStaleApplePaySubmit()) {
      return
    }

    const enableEQFastFollow =
      convertToBoolean(APPConfig?.getAppConfig()?.enableEQFastFollow) || false
    const userTypeSponsorId = accountsContainer?.getUserTypeSponsorId() || ''
    const guestSignupOrigin = getGuestSignupOrigin() || ''
    const submitOrderResponse =
      await checkoutContainer.submitOrder(dateTimeStamp)
    const gtmData = cartContainer?.cartResponse || {}
    const chekoutShipmentInfo = this.buildCheckoutShipmentInfo(
      gtmData?.deliveryDetails?.address || ''
    )
    const checkoutAccountInfo = this.buildCheckoutAccountInfo(gtmData)

    this.handleLoading(false)
    if (checkoutContainer.isSuccessResponse(submitOrderResponse)) {
      await this.handleSubmitOrderSuccess({
        gtmData,
        contextValue,
        chekoutShipmentInfo,
        checkoutAccountInfo,
        enableEQFastFollow,
        userTypeSponsorId,
        guestSignupOrigin,
      })
    } else {
      await this.handleSubmitOrderFailure(
        submitOrderResponse,
        chekoutShipmentInfo
      )
    }
  }

  handleSubmitOrder = async dateTimeStamp => {
    const contextValue = checkMysiteOrPersonalOffer()
    const hasSEPAPaymentInCart =
      cartContainer?.cartResponse?.payments?.some(payment =>
        isTwikeyPaymentName(payment?.name)
      ) || false

    if (isExpressCheckout()) {
      const isShippingInfoEventEnabled = enableNewFeature(
        'enableShippingInfoGTMEvent'
      )

      if (isShippingInfoEventEnabled) {
        trackAddShippingInfoEvent({
          cartData: cartContainer?.cartResponse,
        })
      } else {
        trackCustomCheckoutEvent({
          eventType: CHECKOUT_EVENT_TYPES.SHIPPING,
          cartResponse: cartContainer?.cartResponse,
        })
      }
    }

    if (this.handleExpressCreditCardAutoSubmit()) {
      return
    }

    if (isExpressCheckout()) {
      overlayState.showLoader()
    }
    checkoutContainer.autoPaymentSuccess = false

    if (this.props.alipayInitiate && typeof window !== 'undefined') {
      await this.handleAlipaySubmitOrder()
    } else if (
      checkoutContainer.isToInitiateKlarnaPayment &&
      typeof window !== 'undefined'
    ) {
      await this.handleKlarnaSubmitOrder()
    } else if (
      (checkoutContainer.isToInitiateGlobalPayment || hasSEPAPaymentInCart) &&
      !this.shouldSkipGPSInitiateForCSRActOnBehalf()
    ) {
      checkoutContainer.isToInitiateGlobalPayment = true
      await this.handleGlobalPaymentSubmitOrder()
    } else {
      await this.handleStandardSubmitOrder(dateTimeStamp, contextValue)
    }
  }

  renderApplePayConfirmationModal = () => {
    return (
      <Modal
        className="apple-pay-confirmation-modal"
        show={applepayContainer.isToShowApplePayConfirmationModal}
        size="md"
        aria-labelledby="confirm-modal-title"
        onHide={applepayContainer.handleApplePayModalClose}
        centered>
        <Modal.Header className="border-0 apple-pay-modal-header" closeButton>
          <Modal.Title className="font-weight-bold confirmation-text">
            Payment Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="apple-pay-modal-body">
          <span>
            Would you like to proceed with Apple Pay as your payment option?
          </span>
        </Modal.Body>
        <Modal.Footer className="apple-pay-modal-footer d-flex">
          <Col className="modal-button-wrapper">
            <Button
              className="confirm-button"
              variant="primary"
              onClick={() => {
                applepayContainer.isToShowApplePayConfirmationModal = false
                applepayContainer.createApplePayPaymentSession(
                  applepayContainer.applepayCheckoutInstance
                )
              }}>
              Yes, Proceed
            </Button>
          </Col>
          <Col className="modal-button-wrapper">
            <Button
              className="cancel-button"
              variant="primary"
              onClick={() => {
                applepayContainer.handleApplePayModalClose()
              }}>
              Cancel
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>
    )
  }

  renderGooglePayConfirmationModal = () => {
    return (
      <Modal
        className="google-pay-confirmation-modal"
        show={googlePayContainer.isToShowConfirmationModal}
        size="md"
        aria-labelledby="confirm-modal-title"
        onHide={googlePayContainer.handleGooglePayModalClose}
        centered>
        <Modal.Header className="border-0 google-pay-modal-header" closeButton>
          <Modal.Title className="font-weight-bold confirmation-text">
            Payment Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="google-pay-modal-body">
          <span>
            Would you like to proceed with Google Pay as your payment option?
          </span>
        </Modal.Body>
        <Modal.Footer className="google-pay-modal-footer d-flex">
          <Col className="modal-button-wrapper">
            <Button
              className="confirm-button"
              variant="primary"
              onClick={() => {
                googlePayContainer.isToShowConfirmationModal = false
                googlePayContainer.createGooglePayOrder(
                  googlePayContainer.googlePaymentInstance,
                  googlePayContainer.paymentsClient
                )
              }}>
              Yes, Proceed
            </Button>
          </Col>
          <Col className="modal-button-wrapper">
            <Button
              className="cancel-button"
              variant="primary"
              onClick={() => {
                googlePayContainer.handleGooglePayModalClose()
              }}>
              Cancel
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>
    )
  }

  /**
   * @description Renders Submit Order Button for Google Pay Payment
   */
  renderGooglePaySubmitOrderButton = (customClass = '') => {
    return (
      <div id="google-pay-button">
        <Button
          className={`w-100 google-pay-submit-button ${customClass}`}
          variant="success"
          disabled={
            this.isToDisableGooglePaySubmitButton() ||
            checkoutContainer?.isToDisableSubmitOrderButton ||
            (accountsContainer?.showIroncladCheckbox &&
              !accountsContainer?.isMemberAgreementChecked)
          }
          data-testid="qa-google-pay-submit-order"
          onClick={() => {
            googlePayContainer.handleGooglePaySubmitButtonClick(this.props)
          }}>
          {i18nTranslate('review.submitOrder', 'Submit Order')}
        </Button>
      </div>
    )
  }

  /**
   * @description Renders Submit Order Button for Paypal Payment
   */
  renderPayPalSubmitOrderButton = (customClass = '') => {
    // #paypal-container sits above the branded button (z-index: 2) and is the
    // real, always-clickable SDK button, so the overlay's `disabled` attribute
    // alone does not block clicks. The wrapper class lets CSS block that layer
    // while submit is disabled. (TD-5313)
    const isPaypalSubmitDisabled =
      this.isToDisablePaypalSubmitButton() ||
      checkoutContainer?.isToDisableSubmitOrderButton ||
      (accountsContainer?.showIroncladCheckbox &&
        !accountsContainer?.isMemberAgreementChecked)
    return (
      <div
        className={`paypal-submit-order-wrapper${
          isPaypalSubmitDisabled ? ' paypal-submit-order-disabled' : ''
        }`}>
        {/* The PayPal/Braintree SDK renders into this node directly. React must
            never render children into it, or React's tree desyncs from the DOM
            and throws removeChild/insertBefore errors that blank the page. The
            branded button is a sibling overlay under the nearly invisible SDK
            button, so real clicks still reach PayPal. */}
        <div id="paypal-container" />
        <Button
          className={`w-100 paypal-order-button-color paypal-submit-order-overlay ${customClass}`}
          variant="success"
          disabled={isPaypalSubmitDisabled}
          data-testid="qa-paypal-submit-order"
          aria-hidden="true"
          tabIndex={-1}>
          {i18nTranslate('review.submitOrder', 'Submit Order')}
        </Button>
      </div>
    )
  }

  /**
   * @description Renders Submit Order Button for Venmo Payment
   */
  renderVenmoSubmitOrderButton = (customClass = '') => {
    return (
      <div id="venmo-container">
        <Button
          className={`w-100 venmo-order-button-color ${customClass}`}
          variant="success"
          disabled={
            this.isToDisableVenmoSubmitButton() ||
            checkoutContainer?.isToDisableSubmitOrderButton ||
            (accountsContainer?.showIroncladCheckbox &&
              !accountsContainer?.isMemberAgreementChecked)
          }
          onClick={() => {
            venmoContainer.reviewVenmoOrder(this.props)
          }}
          data-testid="qa-venmo-submit-order">
          {i18nTranslate('review.submitOrder', 'Submit Order')}
        </Button>
      </div>
    )
  }

  /**
   * @description Renders Submit Order Button for ApplePay Payment
   */
  renderApplePaySubmitOrderButton = (customClass = '') => {
    return (
      <div id="applepay-container">
        <Button
          className={`w-100 applepay-checkout-submit-button ${customClass}`}
          variant="success"
          disabled={
            this.isToDisableApplePaySubmitButton() ||
            checkoutContainer.isToDisableSubmitOrderButton ||
            (accountsContainer.showIroncladCheckbox &&
              !accountsContainer.isMemberAgreementChecked)
          }
          onClick={() => {
            applepayContainer.reviewApplePayOrder(this.props)
          }}
          data-testid="qa-applepay-submit-order">
          {i18nTranslate('review.submitOrder', 'Submit Order')}
        </Button>
      </div>
    )
  }

  /**
   * @description Renders terms checkbox for live event
   * anchor href will be replaced
   */
  renderTermsCheckbox = () => {
    return (
      <Form>
        <div className="mb-3">
          <Form.Check
            type="checkbox"
            id="event-submit-terms-checkbox"
            label={
              <div className="event-submit-terms-checkbox">
                {i18nTranslate(
                  'event.submitOrderTerms',
                  'By submitting your order, you agree to our'
                )}{' '}
                <a
                  href={i18nTranslate(
                    'event.submitOrderTermsOfSaleLinkUrl',
                    'https://globallive2026.com/products/'
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="event-submit-tc-link">
                  {i18nTranslate(
                    'event.submitOrderTermsOfSaleLink',
                    'Terms of Sale (Venue Pickup, Cancellation, Returns & Exchanges)'
                  )}
                </a>
              </div>
            }
            onChange={e => (this.termsCheckboxChecked = e.target.checked)}
          />
        </div>
      </Form>
    )
  }

  handleSubscriptionModalClose = () => {
    this.showSubscriptionAmountModal = false
    this.resetSubmitOrderRetryState()
  }

  resetSubmitOrderRetryState = () => {
    checkoutContainer.isToDisableSubmitOrderButton = false
    if (isExpressCheckout()) {
      checkoutContainer.activeSubmitOrderButton = true
    }
  }

  handleSubscriptionModalContinue = async () => {
    this.handleSubscriptionModalClose()
    await this.patchSubscriptionGroupNameToCart()
  }

  scrollToPaymetricForm = () => {
    const section =
      document.querySelector('[data-testid="qa-add-payment-container"]') ||
      document.querySelector('[data-testid="qa-edit-payment-container"]') ||
      document.querySelector('.paymetric-block-card')
    section?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  checkSubmitGuards = () => {
    const isRegularCheckoutDisabled =
      !isExpressCheckout() && checkoutContainer.isToDisableSubmitOrderButton
    if (isRegularCheckoutDisabled) {
      return true
    }

    const isExpressCheckoutBlocked =
      isExpressCheckout() &&
      !checkoutContainer.activeSubmitOrderButton &&
      !checkoutContainer.expressPaymentAdded
    if (isExpressCheckoutBlocked) {
      return true
    }

    if (isExpressCheckout()) {
      checkoutContainer.activeSubmitOrderButton = false
    } else {
      checkoutContainer.isToDisableSubmitOrderButton = true
    }
    return false
  }

  handleSubmitClick = async () => {
    if (this.checkSubmitGuards()) return

    const paymentType = checkoutContainer.selectedPaymentType
    const isCreditCardPayment = paymentType?.toLowerCase() === 'creditcard'

    // Validate payment selection for GPS-enabled subscription orders
    // When GPS is enabled and cart has subscription products,
    // user must select a payment method (radio button) before submitting
    if (isExpressCheckout() && isGPSEnabled()) {
      const hasSubscriptionProduct = cartContainer.hasSubscriptionProduct()
      const defaultPayment = getDefaultPaymentMethod()
      if (
        hasSubscriptionProduct &&
        defaultPayment === 'razorpay' &&
        paymentType?.toLowerCase() === 'razorpay'
      ) {
        toastState.setToastMessage(
          i18nTranslate(
            'checkout.selectPaymentMethod',
            'Please select a payment method to proceed with payment'
          ),
          false
        )
        // Scroll to payment accordion so user can select a payment method
        const paymentAccordion = document.getElementById(
          'qa-checkout-globalpayment-accordion'
        )
        paymentAccordion?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
      }
    }

    // For express checkout, handleSubmitOrder clicks the payment save button
    // which triggers tokenize() → $XIFrame.submit() before placing the order.
    // The guard below is only needed for regular checkout where the card
    // must be saved explicitly before clicking Submit Order.
    if (
      isCreditCardPayment &&
      this.isPaymetricEnabled() &&
      !isExpressCheckout()
    ) {
      const isPaymetricNewCardFlow = !!paymetricContainer?.paymetricIns
      const isCardNotTokenized =
        !paymetricContainer?.paymetricValidData?.isValid
      const hasPreviousSubmitError =
        !!paymetricContainer?.paymetricErrorData?.error

      if (
        isPaymetricNewCardFlow &&
        (isCardNotTokenized || hasPreviousSubmitError)
      ) {
        checkoutContainer.isToDisableSubmitOrderButton = false
        this.scrollToPaymetricForm()
        return
      }
    }

    if (isINMarket() && cartContainer.hasSubscriptionProduct()) {
      this.showSubscriptionAmountModal = true
    } else {
      // For configured saved GPS credit cards in express checkout, CVV must be
      // collected via the Continue button before addPaymentToCart runs.
      if (isExpressCheckout() && !checkoutContainer.expressPaymentAdded) {
        const savedPayments = customerContainer?.paymentResponse?.payments || []
        // Prefer the card the user actually selected; fall back to
        // default/first only when no explicit selection is available.
        const userSelectedSavedPaymentId =
          savedCardsContainer?.selectedSavedPaymentId || ''
        const selectedSavedPayment =
          savedPayments.find(p => p?.id === userSelectedSavedPaymentId) ||
          savedPayments.find(p => p?.isDefault) ||
          savedPayments[0] ||
          {}
        const isSavedCardsTab =
          checkoutContainer.currentPaymentTypeTab === 'savedcards'
        const gpsCreditCardOptions =
          checkoutContainer.globalPaymentResponse?.CREDITCARD || []
        const isPlainCvvSavedGPSCard = paymentName =>
          isExternalGPSCreditCardPaymentName(paymentName, gpsCreditCardOptions)
        const isPlainCvvSavedGPSCardSelected =
          isSavedCardsTab &&
          (isPlainCvvSavedGPSCard(paymentType) ||
            isPlainCvvSavedGPSCard(selectedSavedPayment?.name))

        if (isPlainCvvSavedGPSCardSelected) {
          checkoutContainer.enableAutoSubmit = true
          const handlePaymentElement = document.getElementById(
            'payment-continue-button'
          )

          if (handlePaymentElement) {
            handlePaymentElement.click()
            return
          }
        }
      }
      await this.patchSubscriptionGroupNameToCart()
    }
  }

  renderRecurringSubscriptionAmountModal = () => {
    const { cartResponse } = cartContainer || {}
    const { value = {}, properties = {} } = cartResponse || {}

    // Today's charge - Grand Total (after all discounts)
    const bagValue = Math.abs(
      cartResponse?.paymentValue?.totalAmountUnpaid || 0
    )

    // Get shipping cost
    const shippingCharge = parseFloat(value?.cartDeliveryCharge || 0)

    // Get overall discount from cart
    const overAllDiscount = Math.abs(parseFloat(value?.totalDiscount || 0))

    return (
      <SubscriptionAmountModal
        bagValue={bagValue}
        overAllDiscount={overAllDiscount}
        shippingCharge={shippingCharge}
        onContinue={this.handleSubscriptionModalContinue}
        onClose={this.handleSubscriptionModalClose}
        show={this.showSubscriptionAmountModal}
      />
    )
  }

  /**
   * @description Renders Submit Order Button for Payments except Paypal and Venmo
   */
  renderSubmitOrderButton = (customClass = '') => {
    const selectedPaymentType = (
      checkoutContainer.selectedPaymentType || ''
    ).toLowerCase()
    const hasCartPaymentForGPSFlow =
      (cartContainer?.cartResponse?.payments || []).some(payment => {
        const type = (payment?.type || '').toUpperCase()
        return type !== 'LOYALTY' && type !== 'STORECREDIT'
      }) || false
    const shouldBypassEnableSubmitForGPSAlternate =
      isExpressCheckout() &&
      isGPSEnabled() &&
      !!selectedPaymentType &&
      selectedPaymentType !== 'creditcard' &&
      hasCartPaymentForGPSFlow &&
      !cartContainer.hasSubscriptionProduct()

    const isSubscriptionCheckout = isSubscriptionOverrideCheckoutPage()
    const hasValidPaymentSelected =
      isSubscriptionCheckout &&
      !!selectedPaymentType &&
      selectedPaymentType.length > 0

    const shouldDisableForEnableSubmit =
      !this.props.enableSubmit && !shouldBypassEnableSubmitForGPSAlternate
    const shouldDisableForIronclad =
      accountsContainer.showIroncladCheckbox &&
      !accountsContainer.isMemberAgreementChecked
    const shouldDisableForGuestLegalAgreement = isGuestSubmitOrderPending()
    const subscriptionCheckoutDisableConditions =
      shouldDisableForEnableSubmit ||
      !hasValidPaymentSelected ||
      shouldDisableForIronclad ||
      shouldDisableForGuestLegalAgreement
    const regularCheckoutDisableConditions =
      shouldDisableForEnableSubmit ||
      shouldDisableForIronclad ||
      shouldDisableForGuestLegalAgreement

    const submitButtonConditions = isSubscriptionCheckout
      ? subscriptionCheckoutDisableConditions
      : regularCheckoutDisableConditions

    const isToDisableSubmitButton = checkoutContainer.activeSubmitOrderButton
      ? submitButtonConditions
      : true

    const enableLiveEvent = getLiveEventStatus()

    const buttonDisabled =
      (!this.termsCheckboxChecked && enableLiveEvent === 'true') ||
      isToDisableSubmitButton ||
      (checkoutContainer.isToDisableSubmitOrderButton &&
        !isExpressCheckout()) ||
      checkoutContainer.disableSubmitButtonAsItemsNotDeliverable ||
      this.inventoryDisableInfo.isDisabled ||
      this.submitDisableInfo.isDisabled

    return (
      <Button
        className={`w-100 submit-order-button-color ${customClass}`}
        variant="success"
        disabled={buttonDisabled}
        type="button"
        id="submit-order-button"
        data-testid="qa-submit-order"
        onClick={event => {
          event.preventDefault()
          event.currentTarget.blur()
          this.handleSubmitClick().catch(error => {
            console.error('Submit order click failed:', error)
          })
        }}>
        {i18nTranslate('review.submitOrder', 'Submit Order')}
      </Button>
    )
  }

  /**
   * @description Renders Submit Order Button
   */
  renderSubmitButton = () => {
    const isToShowNewDesign = isSubscriptionFlagEnabled() || false
    let customClass = isToShowNewDesign ? 'submit-order-button' : ''
    if (isExpressCheckout()) {
      customClass += ' express-checkout-button'
    }

    const { value = {} } = cartContainer?.cartResponse || {}
    let grandTotal = value?.grandTotal || 0
    if (grandTotal > 0) {
      if (paypalContainer.paypalInitiate) {
        return this.renderPayPalSubmitOrderButton(customClass)
      }
      if (venmoContainer.venmoInitiate) {
        return this.renderVenmoSubmitOrderButton(customClass)
      }
      if (googlePayContainer.isToInitiateGooglePayPayment) {
        return this.renderGooglePaySubmitOrderButton(customClass)
      }
      if (applepayContainer.applepayInitiate) {
        return this.renderApplePaySubmitOrderButton(customClass)
      }
    }
    return this.renderSubmitOrderButton(customClass)
  }

  // returns boolean for event registered user
  checkEventRegisteredUser() {
    const profileResponse = customerContainer?.profileResponse
    const accountProperties = profileResponse?.accounts?.properties || []
    const userProperty = accountProperties?.filter(
      property => property?.attributeId === 'registeredEvent'
    )
    return userProperty?.[0]?.value || 'false'
  }

  // returns boolean for order hold status
  getOrderHoldStatus = async () => {
    const response = await customerContainer.getProfile()
    const accountProperties = response?.accounts?.properties || []
    const userProperty = accountProperties?.filter(function (property) {
      if (property?.attributeId === 'orderHold') {
        return property
      }
    })

    if (
      (userProperty?.length > 0 && userProperty?.[0]?.value === 'CSOH') ||
      userProperty?.[0]?.value === 'SOH'
    ) {
      return true
    }
    return false
  }

  /**
   * Blocks submission when any sku in the cart is unavailable and not backordered.
   * Computed so it re-evaluates whenever the cart is re-priced, e.g. when a shipping
   * address change resolves a different inventory bin.
   * Bypasses mirror the precedence in CartProducts.checkoutDisable so subscription
   * flows that intentionally allow out-of-stock items are not blocked at submit.
   */
  @computed get inventoryDisableInfo() {
    const notDisabled = { isDisabled: false, message: '' }

    const isToEnableCheckoutForOOSSubscriptionMS =
      isToShowMultipleSubscriptionOptionsInCart() &&
      multipleSubscriptionContainer.subscriptionOption === 'addToExisting'
    if (isToEnableCheckoutForOOSSubscriptionMS) {
      return notDisabled
    }

    const isFlexibleSubscriptionCheckout =
      nuskinSubscriptionContainer.isUserSubscribedBefore() &&
      cartContainer.hasSubscriptionProduct() &&
      isFlexibleSubscriptionFlagEnabled()
    if (isFlexibleSubscriptionCheckout) {
      return notDisabled
    }

    const items = cartContainer?.cartResponse?.items || []
    const isSkuNotAvailable = (inventory = {}) =>
      inventory?.available === false &&
      (inventory?.backOrdered === false || inventory?.backOrdered === null)

    const isSomeSkuNotAvailable = items.some(item =>
      (item?.skus || []).some(sku =>
        isSkuNotAvailable(sku?.inventoryProperties)
      )
    )

    if (!isSomeSkuNotAvailable) {
      return notDisabled
    }

    return {
      isDisabled: true,
      message: i18nTranslate(
        'some.items.unavailable',
        'Some of the items are not available.'
      ),
    }
  }

  // Updates submitDisableInfo state which disables submit button and shows error message
  submitDisable = async () => {
    const enableLiveEvent = getLiveEventStatus()
    const orderHoldStatus = (await this.getOrderHoldStatus()) || false
    const isEventRegisteredUser = this.checkEventRegisteredUser()

    if (orderHoldStatus) {
      this.submitDisableInfo.isDisabled = true
      this.submitDisableInfo.message = i18nTranslate(
        'account.onhold',
        'Account is on hold'
      )
    } else {
      const itemdetails = cartContainer?.cartResponse?.items || []
      const isSkuNotAvailable = (inventory = {}) =>
        inventory?.available === false &&
        (inventory?.backOrdered === false || inventory?.backOrdered === null)

      const isSomeSkuNotAvailable = itemdetails?.some(item => {
        const { skus = [] } = item
        return skus?.some(newitem => {
          return isSkuNotAvailable(newitem?.inventoryProperties)
        })
      })

      if (isSomeSkuNotAvailable) {
        this.submitDisableInfo.isDisabled = true
        this.submitDisableInfo.message = i18nTranslate(
          'some.items.unavailable',
          'Some of the items are not available.'
        )
      } else if (cartContainer?.cartResponse?.errorCode) {
        this.submitDisableInfo.isDisabled = true
        if (cartContainer.cartResponse?.errorCode === 'EOPLOR001') {
          this.submitDisableInfo.message = i18nTranslate(
            'cart.homeMarket',
            'Please switch to your home market to make a purchase.'
          )
        } else if (cartContainer.cartResponse?.errorCode === 'EOSKUPS002') {
          this.submitDisableInfo.message = i18nTranslate(
            'bundle.discontinuedV2Message',
            'Discontinued - This product or promotion has been discontinued',
            {
              nameSpace: 'ssr-resource',
            }
          )
        } else if (
          cartContainer.cartResponse?.errorCode === 'CustomerNotAllowed'
        ) {
          this.submitDisableInfo.isDisabled = true
        } else if (
          cartContainer.cartResponse?.errorCode === 'EOPLOR001' &&
          this.disableSubmitForPaymentCrypt
        ) {
          this.submitDisableInfo.isDisabled = true
          this.submitDisableInfo.message = i18nTranslate(
            'cart.homeMarket',
            'Please switch to your home market to make a purchase.'
          )
        } else {
          this.submitDisableInfo.message =
            cartContainer.cartResponse.errorMessage
        }
      }

      // Disable submit conditions for Live Event
      // CN locale users might get migrated for the July event site
      // submit is disabled for them for non-event sites
      const homeCountry = customerContainer?.getUserHomeCountry()
      const isUserFromCN = homeCountry === 'CN'
      if (enableLiveEvent !== 'true') {
        if (isUserFromCN) {
          this.submitDisableInfo.isDisabled = true
          this.submitDisableInfo.message = i18nTranslate(
            'cart.homeMarket',
            'Please switch to your home market to make a purchase.'
          )
        }
      }
      if (enableLiveEvent === 'true') {
        const isEventUnregisteredUser =
          customerContainer.isRegisterUser && isEventRegisteredUser === 'false'
        const isRetailUser =
          customerContainer?.profileResponse?.accounts?.accountType ===
          'Retail Customer'
        const isEventPhaseBlocked = shouldDisableLiveEventCartAction()

        // Disable submit in event for unregistered users and retail users from CN
        if (
          isEventUnregisteredUser ||
          (isUserFromCN && isRetailUser) ||
          isEventPhaseBlocked
        ) {
          this.submitDisableInfo.isDisabled = true
        }
      }
    }
  }

  render() {
    // const csrAdminName = getLocalStorage('csrAdminName') || ''
    const previousDate = this.handleMaxDate()
    const errorMsgClassName = this.isValidDate ? 'is-valid' : 'is-invalid'
    const enableLiveEvent = getLiveEventStatus()
    if (enableLiveEvent === 'true') {
      this.submitDisable()
    }
    // Preserve existing live event message behavior; only surface inventory message outside live events
    const submitBlockingMessage =
      enableLiveEvent === 'true'
        ? this.submitDisableInfo?.isDisabled
          ? this.submitDisableInfo?.message
          : ''
        : this.inventoryDisableInfo.message
    return (
      <>
        {/* {csrAdminName !== '' && (
        <Col lg={12}>
            <Row
              noGutters
              className="date-picker-wrapper d-flex position-relative">
              <Col lg={4}>
                <Form.Label>
                  {i18nTranslate('checkout.backDateOrder', 'Effective Date')}
                </Form.Label>
              </Col>
              <Col lg={8} className="pl-md-1">
                <Form.Label
                  className={`date-picker-form ${errorMsgClassName} w-100`}>
                  <DatePicker
                    className="form-input"
                    placeholderText={'YYYY/MM/DD'}
                    dateFormat={'yyyy-MM-dd'}
                    selected={this.selectedDate !== -1 && this.selectedDate}
                    locale={
                      getLocaleCodeFromUrl({
                        locationProps: this.props,
                        defaultLocale: 'en_US',
                        isReverseType: true,
                      })?.split('-')?.[0]
                    }
                    onSelect={(date, event) => {
                      this.handleDateChange(date, event)
                    }}
                    onBlur={event => this.handleBlur(event)}
                    // minDate={new Date()}
                    startDate={new Date()}
                    maxDate={new Date(previousDate)}
                    showDisabledMonthNavigation
                  />
                  <div className="date-picker-icon position-absolute">
                    <DatePickerIcon className="mb-2" />
                  </div>
                </Form.Label>
                <Form.Control.Feedback type="invalid">
                  {i18nTranslate(
                    'checkout.backDateErrorMessage',
                    'Please select a valid date'
                  )}
                </Form.Control.Feedback>
              </Col>
            </Row>
          </Col>
        )} */}
        <Col lg={12} className={isExpressCheckout() ? `my-0 p-0` : `my-2 p-0`}>
          {enableLiveEvent === 'true' && this.renderTermsCheckbox()}
          {this.renderSubmitButton()}
          {submitBlockingMessage && (
            <p className="text-danger submit-order-error-message">
              {alertMessageKeys(submitBlockingMessage)}
            </p>
          )}
        </Col>
        {googlePayContainer.isToShowConfirmationModal &&
          this.renderGooglePayConfirmationModal()}
        {/** Confirmation modal integrated for asynchronous calls issue */}
        {this.renderApplePayConfirmationModal()}
        {this.showSubscriptionAmountModal &&
          this.renderRecurringSubscriptionAmountModal()}
      </>
    )
  }
}

export { SubmitOrder }
